module.exports = __webpack_public_path__ + "assets/media/evening.ae2f4b5b.mp3";